import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable } from "../../../theme/Component/BasicTable"
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { useEffect, useState } from "react";
import { _BudgetAusterity, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { SelectBudgetID } from "../BudgetID/SelectBudgetID";

export const BudgetAusterity = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_BudgetAusterity);


    const modal = useModal("", MODAL_md);
    const modalDelete = useModal("Confirmar Eliminación", MODAL_SM);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        let props: any = {
            State: 1
        }
        instance.getBudgetAusterityCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDBudgetAusterity', visible: true },
        { title: 'Códidgo', property: 'BudgetIDStr', visible: true },
        { title: 'Rubro', property: 'BudgetName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Crear Rubro Austeridad");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const deleteItem = () => {
        const x = { ...bean, State: 5 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateBudgetAusterity(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalDelete.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && bean.State === 1, evento: () => { modal.open(`Editar ${bean.BudgetIDStr}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && bean.State === 1, evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "BudgetIDStr"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Rubros Austeridad" >
            <div className="row">
                <div className="col-md-12">
                    <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />


                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('BudgetIDStr') ? 'has-error' : ''}`}>Rubro Presupuestal</label>
                                <SelectBudgetID onChange={(e) => { setBean({ ...bean, BudgetIDStr: e.JsonCode, BudgetName: e.Name }) }} jsonCode={bean.BudgetIDStr} label=" " />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item { }</strong>
                    </ModalConfirm>



                </div>
            </div>
        </BasicPage>
    )
}